export default __webpack_public_path__ + "static/media/engageIcon3.d0e790c2.svg";